export const createProductReviewMutation = /* GraphQL */ `
    mutation createProductReview($input: CreateProductReviewInput!) {
        createProductReview(input: $input) {
            review {
                nickname
                summary
                text
                average_rating
                ratings_breakdown {
                    name
                    value
                }
            }
        }
    }
`
